import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

const About = () => {
	useEffect(() => {
		Aos.init({
			duration: 1500,
			delay: 200,
			offset: 0,
			easing: "ease",
			once: true,
			mirror: false,
			disable: () => {
				return window.innerWidth < 600;
			},
		});

		window.scrollTo(0, 0);
	}, []);

	const hobbies = [
		{
			delay: "1000",
			icon: "fas fa-music odd",
			title: "Listening Music",
		},
		{
			delay: "1400",
			icon: "fas fa-gamepad even",
			title: "Playing Games",
		},
		{
			delay: "1800",
			icon: "fas fa-edit odd",
			title: "Sketching & Doodling",
		},
		{
			delay: "2200",
			icon: "fas fa-photo-video even",
			title: "Photo & Video Editing",
		},
		{
			delay: "2600",
			icon: "fas fa-laptop-code odd",
			title: "Coding",
		},
	];

	const renderHobbies = () => {
		const hobbiesArray = hobbies.map((hobbie) => {
			return (
				<div
					className="item"
					data-aos="fade-down"
					data-aos-delay={hobbie.delay}
					key={hobbie.title}
				>
					<i className={hobbie.icon} />
					<div className="item-label">{hobbie.title}</div>
				</div>
			);
		});

		return hobbiesArray;
	};

	return (
		<div className="about">
			<div className="main-section">
				<div className="about-heading" data-aos="fade-left">
					<h1>About Me</h1>
				</div>
				<div
					className="about-me-container"
					data-aos="fade-in"
					data-aos-duration="1000"
					data-aos-delay="1000"
				>
					I am a Skilled Front-end Engineer with 3 years of experience.
					<br />
					Proficient in developing optimized and visually appealing Front-end Web Applications.
					<br />
					Fluent with Front-end Skills like:
					<br />
					TypeScript | Vue JS | React JS | SCSS
					<br />
					Worked with Real-Time systems and good knowledge in creating Libraries.
				</div>
				<div className="about-scroll-arrow">
					<a href="#hobbies">
						<i className="fas fa-arrow-down" />
					</a>
				</div>
			</div>

			<div className="section hobbies-section">
				<div className="about-heading" data-aos="fade-right">
					<h1 id="hobbies">Hobbies</h1>
				</div>
				<div
					className="hobbies-container"
					data-aos="fade-in"
					data-aos-delay="1000"
				>
					<div className="hobbies">{renderHobbies()}</div>
				</div>
				<div className="hobbies-scroll-arrow">
					<a href="#education">
						<i className="fas fa-arrow-down" />
					</a>
				</div>
			</div>

			<div className="section">
				<div className="about-heading" data-aos="fade-left">
					<h1 id="education">Education</h1>
				</div>
				<div className="about-content">
					<div
						className="about-item"
						data-aos="fade-in"
						data-aos-duration="1000"
						data-aos-delay="1000"
					>
						<div className="content">
							<h1>
								Bachelor of Technology{" "}
								<i className="fas fa-graduation-cap"></i>
							</h1>
							<h2>Computer Engineering</h2>
							<h4>66.63% | 2016 - 2020</h4>
						</div>
						<a
							href="https://www.poornima.org/poornima-college-of-engineering-2/"
							target="_blank"
							rel="noreferrer"
						>
							<div className="content-card">
								<div className="img-container">
									<img
										src="https://upload.wikimedia.org/wikipedia/en/thumb/9/96/Poornima_College_logo.png/220px-Poornima_College_logo.png"
										alt="Poornima College Of Engineering, Jaipur"
									/>
								</div>
							</div>
						</a>
					</div>
					<div
						className="about-item"
						data-aos="fade-in"
						data-aos-duration="1000"
						data-aos-delay="2000"
					>
						<div className="content">
							<h1>
								12<sup>th</sup> Class{" "}
								<i className="fas fa-school"></i>
							</h1>
							<h2>Central Board of Secondary Education</h2>
							<h4>79.2% | 2016</h4>
						</div>
						<a
							href="https://www.tilakpublicschool.com/"
							target="_blank"
							rel="noreferrer"
						>
							<div className="content-card">
								<div className="img-container">
									<img
										src="https://www.tilakpublicschool.com/assets/img/tilak%20logo-2.png"
										alt="Tilak Public School, Jaipur"
									/>
								</div>
							</div>
						</a>
					</div>
					<div
						className="about-item"
						data-aos="fade-in"
						data-aos-duration="1000"
						data-aos-delay="3000"
					>
						<div className="content">
							<h1>
								10<sup>th</sup> Class{" "}
								<i className="fas fa-school"></i>
							</h1>
							<h2>Central Board of Secondary Education</h2>
							<h4>8.4 CGPA | 2014</h4>
						</div>
						<a
							href="https://www.tilakpublicschool.com/"
							target="_blank"
							rel="noreferrer"
						>
							<div className="content-card">
								<div className="img-container">
									<img
										src="https://www.tilakpublicschool.com/assets/img/tilak%20logo-2.png"
										alt="Tilak Public School, Jaipur"
									/>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default About;
